import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import { getCollect } from 'actions/collect';

export default store => ({
	path: 'wishlist',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'wishlist',
				),
			store,
			'WISHLIST',
		),
		onEnter: withAsyncEnterLoader(
			async (_, __, updateRatio) => {
				// 	updateRatio(0.3);

				await store.dispatch(getCollect());
				updateRatio(0.8);
			},
			store,
			'ENTER_WISHLIST',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/User/Wishlist/index.js